import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormGroup,
    FormGroupDirective,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from 'app/components/tooltip/tooltip.component';

@Component({
    selector: 'revamp-select-general',
    templateUrl: './revamp-select-general-application.component.html',
    styleUrls: ['./revamp-select-general-application.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        TooltipComponent,
        MatTooltipModule,
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
})
export class RevampSelectGeneralApplicationComponent {
    @Input() options: { value: any; label: string }[] = [];
    @Input() label: string = '';
    @Input() placeHolder: string = '';
    @Input() currentValue: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() dropdownToggle: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Input() mandatoryField: boolean = false;
    @Input() controlName?: string;
    @Input() errors: string[] = [];
    @Input() classOverrides: string | null = null;
    @Input() backgroundOverride: string | undefined;
    @Input() isDropdownOpen: boolean;
    @Input() headerUnderline: boolean = false;
    @Input() contentUnderline: boolean = false;
    @Input() tooltipDataHeading: any;
    @Input() monthYear: any;
    @Output() monthClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() yearClick: EventEmitter<void> = new EventEmitter<void>();
    selectedTab: 'month' | 'year' = 'month';
    @Input() showPipe: boolean = false;
    @Input() tooltipDataOption: any = {
        header: 'Working Capital',
        content: 'Financing facility for your daily business operations.',
    };
    @Input() TooltipData = {
        header: '',
        content: '',
    };
    isTooltipOpen: boolean = false;
    isTooltipOpenHeader: boolean = false;

    isFocus: boolean = false;
    @Input() disabled: boolean = false;
    @Input() applyDisableText: boolean = false;

    constructor(
        private el: ElementRef,
        @SkipSelf() private controlContainer: ControlContainer
    ) {}

    getCurrentLabel() {
        return this.options.find((option) => option.value === this.currentValue)
            ?.label;
    }

    get formGroup(): FormGroup | null {
        return this.controlContainer.control as FormGroup;
    }

    get formControl() {
        return this.formGroup?.get(this.controlName ?? '');
    }

    get isDisabled(): boolean {
        return this.disabled || (this.formControl?.disabled ?? false);
    }

    toggleTooltipHeader() {
        this.isTooltipOpen = false;
        this.isTooltipOpenHeader = !this.isTooltipOpenHeader;
    }

    toggleDropdown(e) {
        this.onFocus();
        if (this.options.length > 1) {
            this.isTooltipOpenHeader = false;
            this.isTooltipOpen = false;
            if (this.isDropdownOpen === e) {
                this.closeDropdown();
                return;
            }
            this.isDropdownOpen = e;
            this.dropdownToggle.emit(e);
        }
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    selectOption($event, option: any) {
        $event.stopPropagation();
        this.selectionChange.emit(option);
        this.closeDropdown();
        this.onBlur();
    }

    toggleTooltip(e: any) {
        this.isTooltipOpenHeader = false;
        this.isTooltipOpen = !this.isTooltipOpen;
        e.stopPropagation();
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        this.onBlur();
        if (!this.el.nativeElement.contains(event.target)) {
            this.isTooltipOpen = false;
            this.isTooltipOpenHeader = false;

            // 👇 Added this part
            if (this.isDropdownOpen) {
                this.closeDropdown();
                this.dropdownToggle.emit(false);
            }
        }
    }

    onMonthClick() {
        this.selectedTab = 'month';
        this.monthClick.emit();
        event.stopPropagation();
    }

    onYearClick() {
        this.selectedTab = 'year';
        this.yearClick.emit();
        event.stopPropagation();
    }

    onFocus() {
        this.isFocus = true;
    }

    onBlur() {
        this.isFocus = false;
    }
}
